import React from "react"
import { Link } from "react-router-dom"
import logo from "../../../assets/images/soldx.svg"

const Pages404 = () => {
  document.title = "Page not found | SoldX"

  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center justify-content-center text-center px-3"
      style={{
        background: "#fafafa",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <Link to="/" className="d-block mb-4">
        <img src={logo} alt="SoldX" height="40" />
      </Link>
      {/* Decorative line */}
      <div
        style={{
          width: "60px",
          height: "4px",
          background: "linear-gradient(90deg, #0d6efd, #0a58ca)",
          borderRadius: "2px",
          marginBottom: "2rem",
        }}
      />

      <h1
        className="fw-bold mb-2 lh-1"
        style={{
          fontSize: "clamp(4rem, 18vw, 8rem)",
          color: "#1a1a1a",
          letterSpacing: "-0.04em",
        }}
      >
        404
      </h1>
      <p
        className="mb-1 fw-semibold"
        style={{ fontSize: "1.25rem", color: "#333" }}
      >
        Page not found
      </p>
      <p
        className="mb-4 text-muted"
        style={{ fontSize: "0.95rem", maxWidth: "320px" }}
      >
        This page doesn’t exist or has been moved.
      </p>

      <Link
        className="btn btn-primary btn-lg px-4 rounded-3 fw-semibold"
        to="/dashboard"
        style={{ fontSize: "1rem" }}
      >
        <i className="mdi mdi-arrow-left me-2" />
        Back to Dashboard
      </Link>

      <Link
        className="mt-3 text-decoration-none"
        to="/"
        style={{ fontSize: "0.9rem", color: "#6c757d" }}
      >
        Home
      </Link>

      <p
        className="mt-5 mb-0 small text-black-50"
        style={{ fontSize: "0.8rem" }}
      >
        © {new Date().getFullYear()} SoldX
      </p>
    </div>
  )
}

export default Pages404
